/** Pixel height of the in-flow update banner; must match `AppUpdateBanner` layout. */
export const APP_UPDATE_BANNER_HEIGHT_PX = 50;
